const BASE_COLORS: readonly [number, number, number][] = [
  [0, 82, 48],
  [30, 90, 52],
  [60, 85, 48],
  [120, 68, 42],
  [180, 78, 44],
  [220, 80, 52],
  [270, 72, 54],
  [330, 80, 52],
  [25, 60, 35],
  [0, 0, 52],
  [220, 18, 22]
] as const

const COLOR_VARIANTS: readonly [number, number][] = [
  [0, 0],
  [0, 20],
  [0, -16],
  [-22, 0]
] as const

export type MaterialColorByName = Map<string, string>

const hashName = (name: string): number => {
  let hash = 0
  for (let i = 0; i < name.length; i++) {
    hash = (hash * 31 + name.charCodeAt(i)) >>> 0
  }
  return hash
}

export const getMaterialColor = (name: string): string => {
  const [h, s, l] = BASE_COLORS[hashName(name) % BASE_COLORS.length]
  return `hsl(${h}, ${s}%, ${l}%)`
}

export const buildMaterialColorMap = (materials: string[]): MaterialColorByName => {
  const slotUsage: Record<number, number> = {}
  const assignment: MaterialColorByName = new Map()

  for (const material of [...materials].sort()) {
    const slot = hashName(material) % BASE_COLORS.length
    const variantIndex = slotUsage[slot] ?? 0
    slotUsage[slot] = variantIndex + 1

    const [hue, saturation, lightness] = BASE_COLORS[slot]
    const [saturationDelta, lightnessDelta] = COLOR_VARIANTS[variantIndex % COLOR_VARIANTS.length]
    const finalSaturation = Math.max(30, Math.min(95, saturation + saturationDelta))
    const finalLightness = Math.max(28, Math.min(72, lightness + lightnessDelta))
    assignment.set(material, `hsl(${hue}, ${finalSaturation}%, ${finalLightness}%)`)
  }

  return assignment
}
